import { render, staticRenderFns } from "./resource-asset-complete-training.vue?vue&type=template&id=d56d9612&"
import script from "./resource-asset-complete-training.vue?vue&type=script&lang=ts&"
export * from "./resource-asset-complete-training.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports